import SubmissionTypeField from './SubmissionTypeField';

export default SubmissionTypeField;
